// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import AcademySvg from "./assets/Academy.svg";
import StarFilledSvg from "./assets/star-filled.svg";
import StarUnfilledSvg from "./assets/star-unfilled.svg";
import * as Client_assets from "@literacyplanet/client_assets";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import Numerals0Svg from "./assets/handwriting/Numerals 0-9.svg";
import BookSvg from "./assets/senior_strand_icons/Book.svg";
import GrammarSvg from "./assets/junior_strand_icons/Grammar.svg";
import PhonicsSvg from "./assets/junior_strand_icons/Phonics.svg";
import WritingSvg from "./assets/junior_strand_icons/Writing.svg";
import GrammarSvg$1 from "./assets/senior_strand_icons/Grammar.svg";
import * as AcademyIcons$LiteracyplanetClientSxEntry from "./AcademyIcons.res.mjs";
import SpellingSvg from "./assets/junior_strand_icons/Spelling.svg";
import SpellingSvg$1 from "./assets/senior_strand_icons/Spelling.svg";
import DecodableSvg from "./assets/junior_strand_icons/Decodable.svg";
import HandwritingSvg from "./assets/junior_strand_icons/Handwriting.svg";
import Sight_WordsSvg from "./assets/junior_strand_icons/Sight_Words.svg";
import ZigZagLetterFamilySvg from "./assets/handwriting/Zig-Zag Letter Family.svg";
import ComprehensionSvg from "./assets/junior_strand_icons/Comprehension.svg";
import ComprehensionSvg$1 from "./assets/senior_strand_icons/Comprehension.svg";
import * as WordFlyersTrophies$LiteracyplanetClientSxEntry from "../word_flyers/assets/WordFlyersTrophies.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";
import CurlyLineLetterFamilySvg from "./assets/handwriting/Curly Line Letter Family.svg";
import BouncyLineLetterFamilySvg from "./assets/handwriting/Bouncy Line Letter Family.svg";
import StraightLineLetterFamilySvg from "./assets/handwriting/Straight Line Letter Family.svg";

import './parallax.css'
;

var academyHouseSvg = AcademySvg;

var comprehensionStrandIcon = ComprehensionSvg;

var decodableStrandIcon = DecodableSvg;

var grammarStrandIcon = GrammarSvg;

var handwritingStrandIcon = HandwritingSvg;

var bouncyLineLetterFamilyIcon = BouncyLineLetterFamilySvg;

var curlyLineLetterFamilyIcon = CurlyLineLetterFamilySvg;

var straightLineLetterFamilyIcon = StraightLineLetterFamilySvg;

var zigZagLetterFamilyIcon = ZigZagLetterFamilySvg;

var numeralsZeroToNineIcon = Numerals0Svg;

var phonicsStrandIcon = PhonicsSvg;

var sightWordsStrandIcon = Sight_WordsSvg;

var spellingStrandIcon = SpellingSvg;

var writingStrandIcon = WritingSvg;

var seniorBookStrandIcon = BookSvg;

var seniorComprehensionStrandIcon = ComprehensionSvg$1;

var seniorGrammarStrandIcon = GrammarSvg$1;

var seniorSpellingStrandIcon = SpellingSvg$1;

var starFilledSvg = StarFilledSvg;

var starUnfilledSvg = StarUnfilledSvg;

var scroll = (function(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

function AcademyParallaxUi$ScreenWindow(props) {
  var __navigateToWindow = props.navigateToWindow;
  var i = props.i;
  var navigateToWindow = __navigateToWindow !== undefined ? __navigateToWindow : false;
  var domRef = React.useRef(null);
  var isInView = React$1.useInView(domRef, {
        amount: 0.9
      });
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onActiveCategoryWindowChanged = match.onActiveCategoryWindowChanged;
  React.useEffect((function () {
          if (isInView) {
            onActiveCategoryWindowChanged(i);
          }
          
        }), [isInView]);
  React.useEffect((function () {
          if (navigateToWindow) {
            scroll(domRef.current);
          }
          
        }), [navigateToWindow]);
  return React.createElement("div", {
              key: String(i),
              ref: Caml_option.some(domRef),
              className: "academy__parallax__screen__window academy__parallax__screen__window-" + String(i)
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge("academy__parallax__screen__window__page", isInView ? "academy__parallax__screen__window__page-active" : "")
                }, props.children));
}

var ScreenWindow = {
  make: AcademyParallaxUi$ScreenWindow
};

function AcademyParallaxUi$Levels(props) {
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickLevel = match.onClickLevel;
  var currentLevel = match.currentLevel;
  return React.createElement("aside", {
              className: "academy__levels"
            }, React.createElement("div", {
                  className: "academy__levels__panel"
                }, React.createElement("div", {
                      className: "academy__levels__house"
                    }, React.createElement("img", {
                          className: "academy__levels__house__image",
                          alt: "Academy",
                          src: academyHouseSvg
                        })), React.createElement("ul", {
                      className: "academy__levels__rail"
                    }, Belt_Array.map(match.query.levels, (function (param) {
                            var levelName = param[1];
                            var level = param[0];
                            var isActive = currentLevel === level;
                            return React.createElement("li", {
                                        key: levelName,
                                        className: TailwindMerge.twMerge("academy__levels__item", isActive ? "academy__levels__item--active" : "")
                                      }, React.createElement("button", {
                                            className: "academy__levels__item__button",
                                            onClick: (function (param) {
                                                onClickLevel(level);
                                              })
                                          }, React.createElement("span", {
                                                className: "academy__levels__item__label"
                                              }, levelName), isActive ? React.createElement("span", {
                                                  "aria-hidden": true,
                                                  className: "academy__levels__item__action"
                                                }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.DoubleChevronRight.make, {
                                                      className: "academy__levels__item__action__icon"
                                                    })) : null));
                          })))));
}

var Levels = {
  make: AcademyParallaxUi$Levels
};

function renderNull(v, f) {
  return Belt_Option.mapWithDefault(v, null, f);
}

function AcademyParallaxUi$StarRating(props) {
  var filledCount;
  switch (props.trophy) {
    case "Glass" :
        filledCount = 0;
        break;
    case "Bronze" :
        filledCount = 1;
        break;
    case "Silver" :
        filledCount = 2;
        break;
    case "Gold" :
        filledCount = 3;
        break;
    
  }
  return React.createElement("div", {
              className: "academy__star-rating"
            }, Belt_Array.map([
                  1,
                  2,
                  3
                ], (function (i) {
                    return React.createElement("img", {
                                key: String(i),
                                className: "academy__star-rating__star",
                                alt: "",
                                src: i <= filledCount ? starFilledSvg : starUnfilledSvg
                              });
                  })));
}

var StarRating = {
  make: AcademyParallaxUi$StarRating
};

var dictionary = {};

dictionary["Comprehension"] = comprehensionStrandIcon;

dictionary["Grammar"] = grammarStrandIcon;

dictionary["Decodable"] = decodableStrandIcon;

dictionary["Handwriting"] = handwritingStrandIcon;

dictionary["Bouncy Line Letter Family"] = bouncyLineLetterFamilyIcon;

dictionary["Curly Line Letter Family"] = curlyLineLetterFamilyIcon;

dictionary["Straight Line Letter Family"] = straightLineLetterFamilyIcon;

dictionary["Zig-Zag Letter Family"] = zigZagLetterFamilyIcon;

dictionary["Numbers 0-9"] = numeralsZeroToNineIcon;

dictionary["Phonics"] = phonicsStrandIcon;

dictionary["Sight Words"] = sightWordsStrandIcon;

dictionary["Spelling"] = spellingStrandIcon;

dictionary["Writing"] = writingStrandIcon;

var dictionary$1 = {};

dictionary$1["Book"] = seniorBookStrandIcon;

dictionary$1["Comprehension"] = seniorComprehensionStrandIcon;

dictionary$1["Grammar"] = seniorGrammarStrandIcon;

dictionary$1["Spelling"] = seniorSpellingStrandIcon;

function isSeniorLevel(level) {
  if (level === "LEVEL_9" || level === "LEVEL_8" || level === "LEVEL_7" || level === "LEVEL_6" || level === "LEVEL_5" || level === "LEVEL_4" || level === "LEVEL_12" || level === "LEVEL_11") {
    return true;
  } else {
    return level === "LEVEL_10";
  }
}

function AcademyParallaxUi$RenderData(props) {
  var data = props.data;
  var i = props.i;
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickActivity = match.onClickActivity;
  var onClickCategory = match.onClickCategory;
  var onGetMatrix = match.onGetMatrix;
  var query = match.query;
  var useSeniorIcons = isSeniorLevel(match.currentLevel);
  var tmp;
  var exit = 0;
  if (typeof data !== "object") {
    tmp = null;
  } else {
    switch (data.TAG) {
      case "Strands" :
      case "Categories" :
          exit = 1;
          break;
      case "Activities" :
          tmp = Belt_Array.map(data._0, (function (activity) {
                  var isCompleted = activity.progressState === "Finished";
                  var match = activity.score;
                  return React.createElement("div", {
                              key: activity.id,
                              className: "academy__activity__card"
                            }, isCompleted ? React.createElement("span", {
                                    "aria-hidden": true,
                                    className: "academy__activity__card__check-badge"
                                  }, "✓") : null, React.createElement("h2", {
                                  className: "academy__activity__card__title"
                                }, activity.title), React.createElement("div", {
                                  className: "academy__activity__card__game__icon"
                                }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.ProgressImageIcon.make, {
                                      imageUrl: Client_assets.primaryActivityIcons.getIcon(activity.kind),
                                      className: "academy__activity__card__game__icon__image",
                                      progressState: activity.progressState
                                    })), React.createElement("div", {
                                  className: "academy__activity__card__actions"
                                }, React.createElement("button", {
                                      className: "academy__activity__card__play",
                                      onClick: (function (param) {
                                          onClickActivity(activity);
                                        })
                                    }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.PlayButton.make, {
                                          className: "academy__activity__card__play-icon"
                                        })), match !== undefined ? React.createElement("div", {
                                        className: "academy__activity__card__trophy"
                                      }, WordFlyersTrophies$LiteracyplanetClientSxEntry.trophyToIcon(match.trophy)) : null));
                }));
          break;
      
    }
  }
  if (exit === 1) {
    tmp = Belt_Array.map(data._0, (function (category) {
            var matrix = onGetMatrix(category.id);
            var strandIcon = useSeniorIcons ? Js_dict.get(dictionary$1, category.title) : Js_dict.get(dictionary, category.title);
            var hasIcon = Belt_Option.isSome(strandIcon);
            var hasSubtitle = Belt_Option.isSome(category.subtitle);
            var shouldUseSmallTitleFont = hasIcon || useSeniorIcons;
            var isActive = Belt_Array.some(query.breadcrumb, (function (bc) {
                    return bc.id === category.id;
                  }));
            var isCompleted = Belt_Option.mapWithDefault(matrix.progress, false, (function (progress) {
                    return progress >= 100;
                  }));
            var subtitle = category.subtitle;
            return JsxPPXReactSupportU.createElementWithKey(category.id, Motion$LiteracyplanetClientFlags.Button.make, {
                        whileTap: {
                          scale: 0.95
                        },
                        whileHover: {
                          scale: 1.05
                        },
                        className: TailwindMerge.twMerge("academy__menu__card", hasIcon ? "academy__menu__card--with-icon" : "", hasSubtitle ? "" : "academy__menu__card--no-subtitle", isActive ? "academy__menu__card-active" : ""),
                        onClick: (function (param) {
                            onClickCategory(category, i);
                          }),
                        children: React.createElement(React.Fragment, {}, React.createElement("div", {
                                  className: "academy__menu__card__check-wrap"
                                }, isCompleted ? React.createElement("span", {
                                        "aria-hidden": true,
                                        className: "academy__menu__card__check-badge"
                                      }, "✓") : (
                                    !hasSubtitle && useSeniorIcons ? React.createElement("div", {
                                            className: "academy__menu__card__activity-fraction"
                                          }, String(Belt_Option.getWithDefault(matrix.uniqueActivityCount, 0)), React.createElement("span", {
                                                className: "academy__menu__card__activity-fraction__divider"
                                              }, " / "), String(matrix.totalActivityCount)) : null
                                  )), React.createElement("div", {
                                  className: "academy__menu__card__content"
                                }, subtitle !== undefined ? React.createElement(React.Fragment, {}, React.createElement("div", {
                                            className: "academy__menu__card__header"
                                          }, React.createElement("h3", {
                                                className: "academy__menu__card__title"
                                              }, category.title)), React.createElement("p", {
                                            className: "academy__menu__card__subtitle"
                                          }, subtitle)) : React.createElement("p", {
                                        className: TailwindMerge.twMerge(shouldUseSmallTitleFont ? "academy__menu__card__title" : "academy__menu__card__subtitle", hasIcon && !shouldUseSmallTitleFont ? "academy__menu__card__subtitle--with-icon" : "")
                                      }, category.title), strandIcon !== undefined ? React.createElement("div", {
                                        className: "academy__menu__card__icon-wrap"
                                      }, React.createElement("img", {
                                            className: "academy__menu__card__icon",
                                            alt: category.title,
                                            src: strandIcon
                                          })) : null), React.createElement("div", {
                                  className: "academy__menu__card__progress-shell"
                                }, React.createElement("div", {
                                      className: "academy__menu__card__progress-track"
                                    }, Belt_Option.mapWithDefault(matrix.progress, null, (function (progress) {
                                            return React.createElement("div", {
                                                        className: "academy__menu__card__progress__bar",
                                                        style: {
                                                          width: String(progress) + "%"
                                                        }
                                                      });
                                          }))), Belt_Option.mapWithDefault(matrix.trophy, null, (function (trophy) {
                                        return React.createElement("div", {
                                                    className: "academy__menu__card__trophy"
                                                  }, React.createElement(AcademyParallaxUi$StarRating, {
                                                        trophy: trophy
                                                      }));
                                      }))))
                      });
          }));
  }
  return React.createElement("div", {
              className: TailwindMerge.twMerge("academy__menu__grid", i === 0 ? "academy__menu__grid-first-window" : "")
            }, tmp);
}

var RenderData = {
  make: AcademyParallaxUi$RenderData
};

function AcademyParallaxUi$Menu(props) {
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var loadWindow = match.loadWindow;
  var tmp;
  tmp = typeof loadWindow !== "object" || loadWindow.TAG !== "LoadNewWindow" ? null : React.createElement(AcademyParallaxUi$ScreenWindow, {
          id: "",
          i: loadWindow._0,
          navigateToWindow: true,
          children: null
        });
  return React.createElement(React.Fragment, {}, Belt_Array.mapWithIndex(match.query.data, (function (i, data) {
                    if (typeof loadWindow === "object") {
                      switch (loadWindow.TAG) {
                        case "LoadNewWindow" :
                            break;
                        case "ReplaceExistingWindow" :
                            var replaceAt = loadWindow._0;
                            if (replaceAt === i) {
                              return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: null
                                        });
                            }
                            if (i > replaceAt) {
                              return null;
                            }
                            break;
                        case "NavigateToWindow" :
                            if (loadWindow._0 === i) {
                              return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: React.createElement(AcademyParallaxUi$RenderData, {
                                                i: i,
                                                data: data
                                              })
                                        });
                            }
                            break;
                        
                      }
                    }
                    return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                id: "",
                                i: i,
                                children: React.createElement(AcademyParallaxUi$RenderData, {
                                      i: i,
                                      data: data
                                    })
                              });
                  })), tmp);
}

var Menu = {
  make: AcademyParallaxUi$Menu
};

function AcademyParallaxUi(props) {
  var ref = React.useRef(null);
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickBreadcrumb = match.onClickBreadcrumb;
  var activeCategoryWindow = match.activeCategoryWindow;
  var background = match.background;
  var backgroundImageStyle;
  backgroundImageStyle = typeof background !== "object" ? (
      background === "LoadingBg" ? ({}) : ({
            backgroundImage: "url('https://assets.literacyplanet.com/storyverse/book_of_goings/locations/shabby_woods/full/shabby_hut.webp')"
          })
    ) : ({
        backgroundImage: "url('https://assets.literacyplanet.com/storyverse/book_of_goings/" + background._0 + "')"
      });
  return React.createElement("div", {
              className: "academy__parallax",
              style: backgroundImageStyle
            }, React.createElement("div", {
                  ref: Caml_option.some(ref),
                  className: "academy__parallax__screen"
                }, React.createElement(AcademyParallaxUi$Menu, {})), React.createElement("div", {
                  className: "academy__parallax__breadcrumb"
                }, React.createElement("div", {
                      className: "academy__parallax__breadcrumb_strands"
                    }, Belt_Array.mapWithIndex(match.query.breadcrumb, (function (i, bc) {
                            return JsxPPXReactSupportU.createElementVariadicWithKey(bc.id, Motion$LiteracyplanetClientFlags.Div.make, {
                                        initial: {
                                          scale: 1.0
                                        },
                                        animate: {
                                          scale: activeCategoryWindow === i ? 1.2 : 1.0
                                        },
                                        transition: {
                                          duration: 0.3,
                                          ease: "easeOut"
                                        },
                                        className: TailwindMerge.twMerge("academy__parallax__breadcrumb_links", activeCategoryWindow === i ? "academy__parallax__breadcrumb_links-active" : "", activeCategoryWindow < i ? "academy__parallax__breadcrumb_links-dimmed" : ""),
                                        onClick: (function (param) {
                                            onClickBreadcrumb(i);
                                          }),
                                        children: Caml_option.some(null)
                                      }, [
                                        bc.title,
                                        React.createElement("span", {
                                              "aria-hidden": true
                                            }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.DoubleChevronRight.make, {
                                                  className: "academy__parallax__breadcrumb_links__icon"
                                                }))
                                      ]);
                          })))), React.createElement(AcademyParallaxUi$Levels, {}));
}

var juniorIconByTitle = dictionary;

var seniorIconByTitle = dictionary$1;

var make = AcademyParallaxUi;

export {
  academyHouseSvg ,
  comprehensionStrandIcon ,
  decodableStrandIcon ,
  grammarStrandIcon ,
  handwritingStrandIcon ,
  bouncyLineLetterFamilyIcon ,
  curlyLineLetterFamilyIcon ,
  straightLineLetterFamilyIcon ,
  zigZagLetterFamilyIcon ,
  numeralsZeroToNineIcon ,
  phonicsStrandIcon ,
  sightWordsStrandIcon ,
  spellingStrandIcon ,
  writingStrandIcon ,
  seniorBookStrandIcon ,
  seniorComprehensionStrandIcon ,
  seniorGrammarStrandIcon ,
  seniorSpellingStrandIcon ,
  starFilledSvg ,
  starUnfilledSvg ,
  scroll ,
  ScreenWindow ,
  Levels ,
  renderNull ,
  StarRating ,
  juniorIconByTitle ,
  seniorIconByTitle ,
  isSeniorLevel ,
  RenderData ,
  Menu ,
  make ,
}
/*  Not a pure module */
